<template>
  <div class="stripe-card-wrapper">
    <div class="back-btn" @click.prevent="cancel" v-if="!hideCancel">
      <a href="#">
        <i class="icon ion-arrow-left-c"></i>
        Back
      </a>
    </div>
    <div class="stripe-card">
      <form action="/charge" method="post" ref="paymentForm">
        <div class="form-row">
          <label class="card-label" for="card-element"> Credit Card Number </label>
          <div ref="stripeCardEl">
            <!-- A Stripe Element will be inserted here. -->
          </div>

          <!-- Used to display form errors. -->
          <div class="card-error" role="alert" v-if="errorMessage">
            {{ errorMessage }}
          </div>
        </div>
      </form>
    </div>
    <!-- <div class="next-time">
    <p>
      *Your card will be saved for next time.
    </p>
  </div> -->
  </div>
</template>

<script>
import Promise from 'bluebird'
import stripeLib from 'lib/stripe'

import paymentProfileService from 'api/paymentProfile'

const stripeElements = stripeLib.client.elements()

export default {
  name: 'stripe-card',
  props: {
    hideCancel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      stripeCard: null,
      errorMessage: null,
    }
  },
  methods: {
    validatePaymentProfile() {
      this.errorMessage = null

      return Promise.resolve(stripeLib.client.createToken(this.stripeCard)).tap((result) => {
        if (result.error) {
          this.errorMessage = result.error.message
          this.loading = false

          throw new Error(result.error.message)
        }

        this.currentNonce = result.token.id
      })
    },
    savePaymentProfile() {
      this.errorMessage = null
      this.loading = true

      return this.validatePaymentProfile()
        .then(() => {
          return paymentProfileService.create({
            providerToken: this.currentNonce,
            providerType: 'STRIPE',
          })
        })
        .then((paymentProfile) => {
          this.loading = false

          return paymentProfile
        })
    },
    cancel() {
      this.$emit('cancelled')
    },
  },
  mounted() {
    this.stripeCard = stripeElements.create('card', {
      style: {
        base: {
          color: '#32325d',
          lineHeight: '18px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#8894A4',
          },
        },
      },
    })

    this.stripeCard.mount(this.$refs.stripeCardEl)
  },
  destroyed() {
    this.stripeCard.destroy()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/StripeCard.vue